export const MUST_SUBSCRIBE_ERROR_EVENT = 'mustSubscribeError';

export function showMustSubscribe(data = {}) {
	const event = new CustomEvent(MUST_SUBSCRIBE_ERROR_EVENT, {
		detail: {
			...data
		}
	});

	window.dispatchEvent(event);
}
